import './FooterThemeTen.css';

import CommonService from '../../../../services/commonService';
import React from 'react';
import getIcons from '../../functions/getIcons/getIcons';

function FooterThemeTen() {
	const operator = CommonService.getLocal('op') || {};
	const opname = operator && operator.operator_name;

	const getColor = () => {
		if (opname === 'tacoha') {
			return {
				color:
					operator &&
					operator.color_codes &&
					operator.color_codes.secondary_text_color &&
					operator.color_codes.secondary_text_color,
			};
		}
		if (opname === 'sanantonio' || opname === 'traveltur') {
			return {
				color:
					operator &&
					operator.color_codes &&
					operator.color_codes.secondary_text_color &&
					operator.color_codes.secondary_text_color,
			};
		}

		if (opname === 'liquine') {
			return {
				color: operator && operator.text_color,
			};
		}
		return {
			color: '',
		};
	};
	return (
		<div>
			<div
				className="footerten less-bold-text"
				style={{
					background:
						operator &&
						operator.color_codes &&
						operator.color_codes.footer_color &&
						operator.color_codes.footer_color,
				}}
			>
				<div className="logo-box">
					<a href="/">
						<img
							// src={getIcons('headerLogo', operator)}
							alt=""
							src={operator && operator.footer_logo ? operator.footer_logo : ''}
							style={{
								marginTop: '0',
								width: operator && operator.footer_logo_width && operator.footer_logo_width,
								// height: operator.operator_name === 'centraltour' ? 40 : 50,
							}}
						/>
					</a>
				</div>
				<div className="new-container">
					<div className={opname === 'traveltur' ? 'links-list bold-text' : 'links-list '}>
						{operator &&
							operator.show_header_links && operator.show_header_links.length > 0 &&
							operator.header_links.map((val, index, arr) => {
								return (
									<a
										// className="montserrat-bold"
										key={index}
										style={{
											color: getColor().color,
										}}
										href={Object.values(val)}
									>
										{(index !== 0 || (index !== arr.length - 1 && index !== 0)) && (
											<span className="px-4">|</span>
										)}
										{Object.keys(val)}
									</a>
								);
							})}
						{operator && operator.operator_name == 'andimar' && <span className="px-4">|</span>}
						{operator && operator.operator_name == 'andimar' && (
							<a
								href="/privacy-policy"
								style={{
									color: operator.text_color,
								}}
							>
								Privacy Policy
							</a>
						)}

						{operator && operator.operator_name == 'traveltur' && (
							<span
								className="px-4"
								style={{
									color: getColor().color,
								}}
							>
								|
							</span>
						)}
						{operator && operator.operator_name == 'traveltur' && (
							<a
								href="/terms"
								style={{
									color: getColor().color,
								}}
							>
								Términos y condiciones
							</a>
						)}
					</div>
					<div
						className={'contact-details mt-2'}
						style={{
							color: getColor().color,
						}}
					>
						<div className="contact-details-item">
							<img
								src={opname != 'traveltur' && getIcons('TelephoneIconFooter', operator)}
								alt=""
								style={{ width: 20, marginRight: 5 }}
							/>
							<span>{operator && operator.phone_number}</span>
						</div>
						<span className="px-2">|</span>
						<div className="contact-details-item">
							<img
								src={opname != 'traveltur' && getIcons('EmailIconFooter', operator)}
								alt=""
								style={{ width: 20, marginRight: 5 }}
							/>
							<span>{operator && operator.email}</span>
						</div>
					</div>
				</div>
			</div>
			{operator && operator.show_bottom_footer ? <ShowBottomFooter operator={operator} /> : null}
		</div>
	);
}

const ShowBottomFooter = ({ operator }) => {
	return (
		<div
			className="d-flex-c f-13 p-2"
			style={{
				background: operator && operator.color_codes ? operator.color_codes.sub_footer_color : '',
				color: 'white',
			}}
		>
			<div>
				<span>{operator.operator_name === 'tacoha' ? 'Tacoha' : operator.name} 2023 </span>
				<span>
					{' '}
					- Todos los derechos reservados © | <b>Mapa del sitio</b> | Powered by{' '}
				</span>
				<a href="https://kupos.cl" target="_blank">
					<img
						src={getIcons('kuposLogo', operator)}
						// alt={this.props.t('TRANSLATIONS.VIATUR_LOGO')}
						className="footer-kupos-logo"
						alt=""
					/>
				</a>
			</div>
		</div>
	);
};

export default FooterThemeTen;



// WEBPACK FOOTER //
// ./src/features/themes/common/footer/FooterThemeTen.js